import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

export enum ObserverBreakpoints {
  'XS' = 'xs',
  'SM' = 'sm',
  'MD' = 'md',
  'LG' = 'lg',
  'XL' = 'xl',
}

@Injectable({
  providedIn: 'root',
})
export class ScreenBreakpointObserverService {
  xsBreakpoint = ['(max-width:575.98px)'];
  smBreakpoint = ['(min-width:576px) and (max-width:767.98px)'];
  mdBreakpoint = ['(min-width:768px) and (max-width:991.98px)'];
  lgBreakpoint = ['(min-width:992px) and (max-width:1199.98px)'];
  xlBreakpoint = '(min-width:1200px)';

  public screenSizeObserver = new BehaviorSubject<ObserverBreakpoints[]>([
    ObserverBreakpoints.XS,
  ]);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.initObservers();
  }

  private initObservers() {
    this.breakpointObserver
      .observe(this.xsBreakpoint)
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.screenSizeObserver.next([ObserverBreakpoints.XS]);
        }
      });
    this.breakpointObserver
      .observe(this.smBreakpoint)
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.screenSizeObserver.next([
            ObserverBreakpoints.XS,
            ObserverBreakpoints.SM,
          ]);
        }
      });
    this.breakpointObserver
      .observe(this.mdBreakpoint)
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.screenSizeObserver.next([
            ObserverBreakpoints.XS,
            ObserverBreakpoints.SM,
            ObserverBreakpoints.MD,
          ]);
        }
      });
    this.breakpointObserver
      .observe(this.lgBreakpoint)
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.screenSizeObserver.next([
            ObserverBreakpoints.XS,
            ObserverBreakpoints.SM,
            ObserverBreakpoints.MD,
            ObserverBreakpoints.LG,
          ]);
        }
      });
    this.breakpointObserver
      .observe(this.xlBreakpoint)
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.screenSizeObserver.next([
            ObserverBreakpoints.XS,
            ObserverBreakpoints.SM,
            ObserverBreakpoints.MD,
            ObserverBreakpoints.LG,
            ObserverBreakpoints.XL,
          ]);
        }
      });
  }
}
